import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle as WarningIcon } from 'react-icons/fa';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import Dataline from 'src/components/common/Dataline';
import Modal from 'src/components/common/Modal';
import WorkspaceAddToAllDropTarget from 'src/components/workspace/components/WorkspaceAddToAllDropTarget';
import WorkspaceCreateDatalineDropTarget from 'src/components/workspace/components/WorkspaceCreateDatalineDropTarget';
import { useWorkspaceContext } from 'src/components/workspace/WorkspaceContext';

export const WORKSPACE_CONTENT = 'workspace-content';
export const WORKSPACE_DATALINE_WRAPPER = 'workspace-dataline-wrapper';

const WorkspaceContent = () => {
  const { t } = useTranslation(['workspace', 'common']);
  const {
    currentReport,
    errorMessage,
    showErrorMessage,
    loadingIndicatorIsShown,
  } = useWorkspaceContext();

  const circularProgressStyles = {
    position: 'absolute',
    left: '50%',
    top: '50%',
  };

  return (
    <Box data-test-id={WORKSPACE_CONTENT}>
      <Stack
        direction="row"
        spacing={5}
        sx={{
          mb: 2,
        }}
      >
        <Box>
          <Typography variant="h2">{t('workspaceTitle')}</Typography>

          <Typography
            sx={{
              py: 2,
            }}
          >
            {t('instruction')}
            <br />
            {t('instructionNote')}
          </Typography>
        </Box>

        <WorkspaceAddToAllDropTarget />
      </Stack>
      <Stack
        direction="column"
        spacing={2}
        data-test-id={WORKSPACE_DATALINE_WRAPPER}
      >
        {currentReport.datalines.length > 0 &&
          currentReport.datalines.map(
            (
              {
                definitionlines,
                driverAnalysis,
                id,
                isExternal,
                invalidities,
                isReadOnly,
                isSaved,
                name,
                renderId,
                returns,
                status,
              },
              index,
            ) => (
              <Dataline
                datalineIndex={index}
                datalineRenderId={String(renderId)}
                definitionlines={definitionlines}
                driverAnalysis={driverAnalysis}
                id={id}
                isExternal={isExternal}
                invalidities={invalidities}
                isReadOnly={isReadOnly}
                isSaved={isSaved}
                key={renderId}
                name={name}
                returns={returns}
                status={status}
              />
            ),
          )}

        <WorkspaceCreateDatalineDropTarget />
      </Stack>
      {errorMessage && (
        <Modal
          className="workspace-page__modal"
          headline={t('common:error')}
          icon={<WarningIcon size={23} />}
          isOpen={!!errorMessage && errorMessage !== ''}
          onClose={() => showErrorMessage()}
        >
          {errorMessage}
        </Modal>
      )}
      {loadingIndicatorIsShown && (
        <Stack>
          <CircularProgress sx={circularProgressStyles} />
        </Stack>
      )}
    </Box>
  );
};

export default WorkspaceContent;
